import { usePUserStore } from '@/store';
import { apiGetUserInfo, RespUserInfo } from '@vas2t-lowcode/api';
import { setDwAccountId } from './dw-collect';
import type { AxiosPromise } from 'axios';

let isExecuted = false;

export const isWpsEnv = () => {
  return !!window.wpsQuery;
};

/**
 * 获取用户信息
 * @param isForce 是否强制
 */
export function getUserInfo(isForce = false) {
  if (isExecuted && !isForce) {
    return Promise.resolve(true);
  }
  // 获取过
  isExecuted = true;

  return getUserInfoBase();
}

/**
 * 设置是否渲染页面
 */
function setIsReady(isReady = true) {
  const userStore = usePUserStore();
  // 渲染页面
  userStore.isReady = isReady;
}

/**
 * 从后台接口获取用户信息
 */
function getUserInfoBase() {
  return new Promise<boolean>((resolve) => {
    // 已经登陆直接渲染页面
    const userStore = usePUserStore();
    if (userStore.userInfo.userid) {
      // 渲染页面
      setIsReady();
      // 成功获取
      resolve(true);
      return;
    }

    reqUserinfoAsync()
      ?.then(({ data }) => {
        userStore.updateUserInfo(data);
        const { userid, did } = data || {};
        // 设置埋点信息 使用did保证和轻流测试同步
        const didNum = did ? Number(did) : '';
        didNum && setDwAccountId(didNum);
        // 成功获取
        resolve(true);
      })
      .catch((err: Error) => {
        // 发生错误
        console.warn(err);
        // 失败
        resolve(false);
      })
      .finally(() => {
        resetUserinfoAsync();
        // 渲染页面
        setIsReady();
      });
  });
}

// /**
//  * 异步调用客户端获取用户信息接口
//  */
// function wpsGetUserInfoAsync() {
//   return new Promise((res) => {
//     window.wps.getUserInfo({
//       complete: (data: any) => {
//         res(data);
//       },
//     });
//   });
// }

// /**
//  * 从客户端SDK获取用户信息
//  */
// function getUserInfoWps() {
//   return new Promise<boolean>(async (resolve) => {
//     const isLogin = await wpsIsLoginAsync();

//     // 未登录
//     if (!isLogin) {
//       // 失败
//       resolve(false);
//       return;
//     }

//     try {
//       // 获取用户基本信息
//       const userInfo = await wpsGetUserInfoAsync();
//       if (userInfo?.login_code) {
//         resolve(false);
//         return;
//       }

//       // window.wps.getUserInfo({
//       //   complete: (res: any) => {
//       //     console.log(res.userInfo.nickname);
//       //     console.log(res.userInfo.gender);
//       //     console.log(res.userInfo.picUrl);
//       //     console.log(res.login_code);
//       //     console.log('用户基本信息; ', res);
//       //     if (!res.login_code) {
//       //       resolve(false);
//       //     }
//       //   },
//       // });

//       const info = {
//         avatar: userInfo.picUrl,
//         nickname: userInfo.nickname,
//         userid: Number(userInfo.login_code), // TODO: 需要后端实现相关接口
//       };
//       // 更新用户信息
//       const userStore = usePUserStore();
//       userStore.updateUserInfo(info);
//       // 设置sentry依赖的用户id
//       setSentryTag4UserId(info.userid);
//       // 成功获取
//       resolve(true);
//     } catch (err) {
//       console.log('getUserInfo: catch', err);
//       // 失败
//       resolve(false);
//     } finally {
//       // 渲染页面
//       setIsReady();
//     }
//   });
// }

// /** wps 客户端 sdk 初始化完成 */
// let isWpsOfficeSDKReady = false;

// /** 判断当前 wps 客户端 sdk 是否初始化完成 */
// const checkWpsEnvReady = () => {
//   if (window.wps && window.__wpsoffice_environment === 'miniprogram') {
//     isWpsOfficeSDKReady = true;
//   }

//   return isWpsOfficeSDKReady;
// };

// /** 判断环境初始化完成 */
// export const initEnv = () => {
//   return new Promise((res, rej) => {
//     checkWpsEnvReady();
//     if (isWpsOfficeSDKReady) {
//       return res;
//     } else {
//       document.addEventListener(
//         'WpsofficeSDKReady',
//         () => {
//           checkWpsEnvReady();
//           res(isWpsOfficeSDKReady);
//         },
//         false
//       );
//     }
//   });
// };

// #region 数据预加载：userinfo 接口
let userinfoReq = undefined as undefined | AxiosPromise<RespUserInfo>;
/** 数据预加载 */
export const reqUserinfoAsync = () => {
  if (!userinfoReq) {
    userinfoReq = window._reqUserinfoAsync || apiGetUserInfo();
    return userinfoReq;
  }

  return userinfoReq;
};

/**
 * 重置预加载的数据, 防止下次 reqUserinfoAsync 获取的为旧数据
 *
 * @returns
 */
export const resetUserinfoAsync = () => {
  userinfoReq = undefined;

  window._reqUserinfoAsync = undefined;
};
// #endregion
